module.exports = __webpack_public_path__ + "img/jishufuwu_bg_banner.min.f4cb6ece.jpg";